import { render, staticRenderFns } from "./BCXMessengerChatMessages.vue?vue&type=template&id=b7a8783e&scoped=true"
import script from "./BCXMessengerChatMessages.vue?vue&type=script&lang=ts"
export * from "./BCXMessengerChatMessages.vue?vue&type=script&lang=ts"
import style0 from "./BCXMessengerChatMessages.vue?vue&type=style&index=0&id=b7a8783e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a8783e",
  null
  
)

export default component.exports